export default __webpack_public_path__ + "static/media/l7.13e963ae.jpg";